<template>
    <div class="mr-2 mr-2 measures">
        <div class="measure-title primary white--text mb-1">
            {{ title }}
        </div>
        <div class="measure-group" >
            <p-inc-measure-card
                class    = "w-100 mb-5"
                v-for    = "(measure, index) in measures"
                :key     = "index"
                :id      = "measure.id"
                :name    = "$t(measure.name)"
                :measure = "measure.measure"
                @click   = "onClick"
            />
        </div>
    </div>
</template>

<script>
import PIncMeasureCard from "@/modules/inc/todos/components/private/PIncMeasureCard.vue";

export default {
    name: "PIncMeasureGroup",

    components: {
        PIncMeasureCard
    },

    props: {
        title: {

        },

        measures: {

        }
    },

    methods: {
        onClick (measure) {
            this.$emit("click", measure);
        }
    }
}
</script>r

<style scoped>

.measures {

}

.measure-title {
    height: 30px;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    padding-top: 3px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.measure-group {

}

</style>